import '../src/scss/style.scss';
import { SctAccordion } from './modules/_SctAccordion';
import { SctApiCheck } from './modules/_SctApiCheck';
// Run Accordion.
new SctAccordion();
// Run Api check.
new SctApiCheck();
